<template>
  <div :class="[{ layout: isMobile }, { column: isMobile }]">
    <!-- 导航 -->
    <cun-nav ref="nav" />
    <!-- 内容 -->
    <div v-if="isMobile" style="height: 56px"></div>
    <router-view />
    <div
      v-if="isMobile && !footerShow && bottomBtn"
      style="height: 80px; background: white"
    ></div>
    <!-- 页脚 -->
    <cun-footer v-if="footerShow" />
  </div>
</template>

<script>
import cunNav from './components/cun-nav.vue'
import cunFooter from './components/cun-footer.vue'
export default {
  components: {
    cunNav,
    cunFooter
  },
  data() {
    return {
      footerShow: false,
      bottomBtn: false
    }
  },
  created() {
    this.setup()
    this.footerShow = this.$route.path === '/'
    this.bottomBtn =
      this.$route.path === '/info' || this.$route.path === '/mysteryBoxInfo'
  },
  watch: {
    // 监听路由发生改变
    $route: {
      handler(newVal) {
        this.footerShow = newVal.path === '/'
        this.bottomBtn =
          this.$route.path === '/info' || this.$route.path === '/mysteryBoxInfo'
      }
    }
  },
  methods: {
    setup() {
      // 关闭loading背景
      // const closeBg = () => {
      // console.log('ad')
      // const loadingBg = document.getElementById('loading').style
      // loadingBg.visibility = 'hidden'
      // loadingBg.opacity = 0
      // const timer = setTimeout(() => {
      //   loadingBg.display = 'none'
      //   clearTimeout(timer)
      // }, 1500)
      // // }
      // // closeBg()
      // return {
      //   language: ref(
      //     ['undefined', undefined].includes(localStorage.language) ? 'Zh' : localStorage.language
      //   )
      // }
    },
    loginOut() {
      // this.$refs.nav.loginout()
    },
    dialogShow() {
      // this.$refs.nav.dialogShow()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/views/layout/index.vue